import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function ChangePasswordDialog({ open, onClose }) {
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [loading, setLoading] = useState(false);

  function reset() { setForm({ current_password: "", new_password: "", confirm: "" }); }

  async function submit(e) {
    e.preventDefault();
    if (form.new_password.length < 6) { toast.error("Parola nouă trebuie să aibă minim 6 caractere"); return; }
    if (form.new_password !== form.confirm) { toast.error("Confirmarea parolei nu corespunde"); return; }
    setLoading(true);
    try {
      await api.post("/auth/change-password", {
        current_password: form.current_password,
        new_password: form.new_password,
      });
      toast.success("Parola a fost schimbată");
      reset();
      onClose();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Eroare");
    } finally { setLoading(false); }
  }

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) { reset(); onClose(); } }}>
      <DialogContent className="max-w-sm" data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle className="font-display tracking-tight">Schimbă parola</DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div>
            <Label>Parola curentă</Label>
            <Input data-testid="cp-current" type="password" value={form.current_password} onChange={(e) => setForm({ ...form, current_password: e.target.value })} required />
          </div>
          <div>
            <Label>Parolă nouă</Label>
            <Input data-testid="cp-new" type="password" value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} required minLength={6} />
          </div>
          <div>
            <Label>Confirmă parola nouă</Label>
            <Input data-testid="cp-confirm" type="password" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} required />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => { reset(); onClose(); }}>Anulează</Button>
            <Button data-testid="cp-submit" type="submit" disabled={loading} className="bg-[#0047FF] hover:bg-[#003BD3]">
              {loading ? "Se schimbă..." : "Salvează"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
